import rewardConfig from './reward';

describe('reward config encoding', () => {
  it('serializes reward amounts with pound signs and no mojibake', () => {
    const serialized = JSON.stringify(rewardConfig);
    const pound = String.fromCharCode(0x00a3);
    const mojibakePound = String.fromCharCode(0x00c2, 0x00a3);
    const replacementCharacter = String.fromCharCode(0xfffd);

    expect(serialized).toContain(`${pound}50`);
    expect(serialized).toContain(`${pound}500`);
    expect(serialized).not.toContain(mojibakePound);
    expect(serialized).not.toContain(replacementCharacter);
  });
});
